var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9831 17.6203V20.6203C22.9842 20.8988 22.9271 21.1745 22.8156 21.4296C22.704 21.6848 22.5404 21.9139 22.3351 22.1022C22.1299 22.2904 21.8876 22.4338 21.6238 22.523C21.36 22.6122 21.0804 22.6454 20.8031 22.6203C17.7259 22.2859 14.7701 21.2344 12.1731 19.5503C9.75688 18.015 7.70839 15.9665 6.17306 13.5503C4.48304 10.9415 3.4313 7.97129 3.10306 4.88029C3.07807 4.60376 3.11093 4.32505 3.19956 4.06192C3.28818 3.79878 3.43063 3.55698 3.61782 3.35191C3.80502 3.14685 4.03286 2.983 4.28685 2.87081C4.54083 2.75863 4.8154 2.70055 5.09306 2.70029H8.09306C8.57836 2.69552 9.04885 2.86737 9.41682 3.18382C9.78479 3.50028 10.0251 3.93974 10.0931 4.42029C10.2197 5.38036 10.4545 6.32302 10.7931 7.23029C10.9276 7.58822 10.9567 7.97721 10.877 8.35117C10.7972 8.72514 10.6119 9.0684 10.3431 9.34029L9.07306 10.6103C10.4966 13.1138 12.5695 15.1867 15.0731 16.6103L16.3431 15.3403C16.6149 15.0714 16.9582 14.8861 17.3322 14.8064C17.7061 14.7266 18.0951 14.7557 18.4531 14.8903C19.3603 15.2288 20.303 15.4637 21.2631 15.5903C21.7488 15.6588 22.1925 15.9035 22.5096 16.2778C22.8267 16.6521 22.9952 17.1299 22.9831 17.6203Z",
    stroke: "#00C9C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.2d6bc4d8b87aeb266badccb4573f9071.svg";
export { ForwardRef as ReactComponent };